import template from './sw-cms-block-sidebar-filter.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
